import React, { FC, useState } from 'react'
import Image from '../../../common/Image/Image'
import styles from './ReviewSlider.module.scss'
import cn from 'classnames'

const ImgSlide: FC<{
  src: string
  index: number
  width: number
  height: number
}> = ({ src, index, width, height }) => {
  const [isHorizon, setIsHorizon] = useState(false)
  const [loading, setLoading] = useState(true)

  function handlerOnLoad(element: HTMLImageElement) {
    setLoading(false)
    setIsHorizon(element.naturalWidth > element.naturalHeight)
  }

  return (
    <>
      <div
        className={cn(
          styles.imgSlide,
          isHorizon
            ? styles['imgSlide--horizon']
            : styles['imgSlide--vertical'],
          loading && styles['imgSlide--hide'],
        )}
      >
        <Image
          src={src}
          alt={`слайд - ${index + 1}`}
          width={width || 670}
          height={height || 800}
          loading={index === 0 ? 'eager' : 'lazy'}
          priority={index === 0}
          onLoad={(el) => handlerOnLoad(el.target as HTMLImageElement)}
        />
      </div>
      <div className={styles.bg}>
        <Image
          src={src}
          alt={`слайд - ${index + 1}`}
          width={670}
          height={800}
          loading={index === 0 ? 'eager' : 'lazy'}
          priority={index === 0}
        />
      </div>
    </>
  )
}

export default ImgSlide
